import { h, Fragment } from 'preact';
import { useEffect, useState, useRef } from 'preact/hooks';
import clsx from 'clsx';
import IconPlay from '../utils/icon/play.svg';
import IconPause from '../utils/icon/pause.svg';
import { useWindowSize } from '../utils/window-size';

const AutoPlayVideo = ({
  mobileVideo,
  desktopVideo,
  classNames,
  controls,
  controlsPlacement,
}) => {
  const { isMobile } = useWindowSize();
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isPausedByUser, setIsPausedByUser] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const playVideo = () => {
    if (!videoRef.current.paused) return;
    videoRef.current.play();
    setIsPlaying(true);
  };

  const pauseVideo = () => {
    if (!videoRef.current || videoRef.current.paused) return;
    videoRef.current.pause();
    setIsPlaying(false);
  };

  useEffect(() => {
    const videoElement = videoRef.current;

    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !isPausedByUser) {
          if (!isPlaying) {
            playVideo();
          }
          setIsVisible(true);
        } else {
          pauseVideo();
          setIsVisible(false);
        }
      });
    };

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    };

    const observer = new IntersectionObserver(handleIntersection, options);
    observer.observe(videoElement);

    return () => {
      observer.unobserve(videoElement);
    };
  }, [isPausedByUser]);

  useEffect(() => {
    if (!isPausedByUser && isVisible) {
      playVideo();
    }
  }, [isPausedByUser, isVisible]);

  return (
    <>
      <div className="relative">
        <video
          ref={videoRef}
          width="320"
          height="240"
          className={clsx(classNames, ' w-full h-auto')}
          loop
          muted
          autoPlay
          playsInline
          src={isMobile ? mobileVideo : desktopVideo}
        />
        {controls && (
          <div
            className={`${
              controlsPlacement || 'bottom-2.5 laptop:bottom-5 justify-end'
            } absolute w-full flex pr-2.5 laptop:pr-5`}
          >
            {videoRef.current && (isPlaying || !videoRef.current.paused) ? (
              <button
                className="playpause bg-white rounded-full h-8 laptop:h-[42px] flex items-center justify-center w-8 laptop:w-[42px]"
                onClick={() => {
                  pauseVideo();
                  setIsPausedByUser(true);
                }}
              >
                <IconPause className="scale-[0.71] laptop:scale-100" />
              </button>
            ) : (
              <button
                className="playpause bg-white rounded-full h-8 laptop:h-[42px] flex items-center justify-center w-8 laptop:w-[42px]"
                onClick={() => {
                  playVideo();
                  setIsPausedByUser(false);
                }}
              >
                <IconPlay className="scale-[0.71] laptop:scale-100" />
              </button>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default AutoPlayVideo;
